
import React, { useState, useEffect, useRef } from "react";

import PrimiumTable from "./PrimiumTable";

import { Link } from "react-router-dom";
const Management2 = ({ plan }) => {
  const subscriptionPlan = plan || localStorage.getItem("planType") || "premium"; <PrimiumTable />
  const isMobile = window.innerWidth <= 768;
  const [isOpen, setIsOpen] = useState(false);
  const [ticketType, setTicketType] = useState("");
  const [message, setMessage] = useState("");
  const [attachment, setAttachment] = useState(""); // base64 image


  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const result = reader.result;
        // Ensure we only get base64 data (after the comma)
        const base64Data = result.split(',')[1];
        setAttachment(base64Data);
      };
      reader.readAsDataURL(file);
    }
  };



  const handleSendTicket = async () => {
    const vendorId = localStorage.getItem("vendorId");
    const token = localStorage.getItem("authToken");

    if (!vendorId || !token) {
      alert("Vendor ID or Token not found in localStorage.");
      return;
    }

    if (!ticketType || !message) {
      alert("Please fill all the fields");
      return;
    }

    const payload = {
      vendorId: Number(vendorId),
      ticketType,
      message,
      attachmentUrl: attachment || "", // base64 encoded image
    };

    try {
      const response = await fetch(
        "https://backend.maamaas.com/food/vendor-tickets/create",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        }
      );

      const result = await response.json();

      if (response.ok) {
        alert("Ticket submitted successfully!");
        setTicketType("");
        setMessage("");
        setAttachment("");
        setIsOpen(false);
      } else {
        console.error("API Error:", result);
        alert(result.message || "Failed to submit ticket.");
      }
    } catch (error) {
      console.error("Fetch Error:", error);
      alert("Something went wrong while submitting the ticket.");
    }
  };
  const renderComponentByPlan = () => {
    switch (subscriptionPlan.toLowerCase()) {
      case "basic":
        return <PrimiumTable />;
      case "standard":
        return <PrimiumTable />;
      // <Tablereservation />
      case "premium":
        return <PrimiumTable />;
      default:
        return <div>Invalid plan selected</div>;
    }
  };

  return (
    <div className="container-fluid">
      <div className="row">
        {/* Left margin or sidebar */}
        <div className="col-lg-2"></div>

        {/* Main content area (component displayed here) */}
        <div className="col-lg-10" style={{ marginTop: "130px" }}>
          <p
            className="breadcrumb maamaas-home-bredcum"
            style={{
              position: "fixed",
              top: isMobile ? "50px" : "80px",
              left: isMobile ? "5px" : "275px",
              width: "100%",
              backgroundColor: "#fff",
              zIndex: 1000,
              padding: "10px 0",
              fontSize: isMobile ? "14px" : "18px",
              fontWeight: isMobile ? "normal" : "bold",
              textAlign: "center",
              margin: 0,
            }}
          >
            {/* <Link
              to="/Newmainlandingpage"
              style={{
                color: "purple",
                fontWeight: "bold",
                textDecoration: "none",
              }}
            >
              Home
            </Link>
            <span className="separator"> &gt; </span> */}
            <Link
              to="/company"
              style={{
                color: "purple",
                fontWeight: "bold",
                textDecoration: "none",
              }}
            >
              Food & Beverages
            </Link>
            <span className="separator"> &gt; </span>
            <Link

              style={{
                color: "purple",
                fontWeight: "bold",
                textDecoration: "none",
              }}
            >
              Table_Management
            </Link>

          </p>
          {renderComponentByPlan()}
        </div>

        {/* Optional right-side content or spacing */}
        {/* <div className="col-lg-3"></div> */}

      </div>
    </div>
  );
};

export default Management2;

